const MS_PER_DAY = 24 * 60 * 60 * 1000;

// timestamp is anything new Date() accepts (e.g. the UTC string from jackson).
const getRelativeTimeDisplay = (timestamp) => {
  if (!timestamp) {
    return null;
  }

  const then = new Date(timestamp);
  if (isNaN(then.getTime())) {
    return null;
  }

  const title = then.toLocaleString("en-US");
  const now = new Date();
  const diffMs = now - then;
  const minutes = Math.floor(diffMs / 60000);

  if (minutes < 1) {
    return { text: "Just now", title };
  }
  if (minutes < 60) {
    return { text: minutes + "m ago", title };
  }
  if (minutes < 60 * 24) {
    return { text: Math.floor(minutes / 60) + "h ago", title };
  }

  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfThenDay = new Date(then.getFullYear(), then.getMonth(), then.getDate());
  const days = Math.round((startOfToday - startOfThenDay) / MS_PER_DAY);

  if (days <= 1) {
    return { text: "Yesterday", title };
  }
  if (days < 60) {
    return { text: days + "d ago", title };
  }
  if (days < 365) {
    return { text: Math.floor(days / 30) + "mo ago", title };
  }
  return { text: Math.floor(days / 365) + "yr ago", title };
};

export { getRelativeTimeDisplay };
